module.exports = __webpack_public_path__ + "static/media/filter.cb0452c6.svg";